module.exports = "https://trybtryb-legacy.web.app/img/yes-solid.62ea744d.svg";